// import { ContentApi, UploadApi, RenditionsApi } from "@alfresco/js-api";
// import { useUserStore } from "@/stores/user";

/* Service permettant la gestion des invitations et des liens de partage.
 *
 * Liens de partage
 *
 * FIXME
 */
export default class AlfrescoPermissionService {
  getPublicLink() {
    // Recupère le liens publique de l'espace de travaille
    // Voir métadonnées avec Cindy
    // <serveur>:<port>/<app>/p/<key>
    // Il faut récupérer la
  }

  createPublicLink() {
    // Créer le liens publique de l'espace de travaille
    // 1. Créer un utilisateur caché username="_public_<rand 16c>" avec mdp password="<rand 16c>"
    // 2. Création d'un hash similaire au hashmac : base64(<format>|<username>|<password>)
    //    Format=1
    // <serveur>:<port>/<app>/p/<key>
  }
}
